import {
	createCardApiV1AuthUserUserIdCardsPost,
	deleteCardApiV1AuthUserUserIdCardsCardIdDelete,
	getUserCardsApiV1AuthUserUserIdCardsGet,
	likeCardApiV1AuthCardsCardIdLikePost,
	updateCardApiV1AuthUserUserIdCardsCardIdPut,
} from "@/shared/api/generated-backend"
import { HttpError } from "@/shared/api/http"
import type { CardCreate, CardUpdate } from "../model/types"

export async function getUserCards(userId: number) {
	const { cards } = await getUserCardsApiV1AuthUserUserIdCardsGet({
		path: { user_id: userId },
	})
	return cards
}

export async function createCard(userId: number, body: CardCreate) {
	return createCardApiV1AuthUserUserIdCardsPost({
		path: { user_id: userId },
		body,
	})
}

export async function deleteCard(userId: number, cardId: number) {
	await deleteCardApiV1AuthUserUserIdCardsCardIdDelete({
		path: { user_id: userId, card_id: cardId },
	})
}

export async function updateCard(
	userId: number,
	cardId: number,
	body: CardUpdate,
) {
	return updateCardApiV1AuthUserUserIdCardsCardIdPut({
		path: { user_id: userId, card_id: cardId },
		body,
	})
}

export async function likeCard(cardId: number) {
	try {
		await likeCardApiV1AuthCardsCardIdLikePost({
			path: { card_id: cardId },
		})
	} catch (error) {
		if (error instanceof HttpError && error.status === 409) {
			return
		}
		throw error
	}
}
